import __vue_component__ from './IconWrapper.vue.js';

var Epic24Icon = {
  name: 'Epic24Icon',
  props: {
    size: {
      type: String
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    }
  },

  render(h) {
    // eslint-disable-next-line max-len
    return h(__vue_component__, {
      props: { ...this.$props
      },
      domProps: {
        innerHTML: '<svg viewBox="0 0 24 24"><path fill="#6554C0" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm15.188 9.4h-3.063V4.8a1.807 1.807 0 0 0-3.16-1.192l-.197.21c-.095.114-.095.114-.324.397a678.151 678.151 0 0 0-2.976 3.699l-.093.117C5.188 12.03 5 12.274 5 12.8c0 1.01.819 1.599 1.77 1.76l.168.014h2.937V19.2c0 .997.815 1.8 1.813 1.8.43 0 .963-.236 1.52-.793l.073-.083.28-.35a1306.403 1306.403 0 0 0 2.973-3.744l.049-.061a403.17 403.17 0 0 0 2.21-2.815c.315-.407.562-.729.734-.96.095-.127.169-.229.223-.306.042-.062.042-.062.085-.13.05-.046.05-.046.165-.558 0-.997-.815-1.8-1.813-1.8zm-5.063 2V5.317a357.977 357.977 0 0 0-.863 1.066 626.68 626.68 0 0 0-2.23 2.778l-.047.058-.046.059c-1.573 1.973-2.217 2.788-2.596 3.296h4.532v6.106l.122-.154a1304.666 1304.666 0 0 0 2.969-3.736l.048-.061A400.017 400.017 0 0 0 17.62 11.4h-4.495z"/></svg>'
      }
    });
  }

};

export default Epic24Icon;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/Epic24Icon.js